export default __webpack_public_path__ + "static/media/not-great@3x.5b6bda9f.png";